import builder from '../builder';
import SavingBankInternational from '../../streamline-icons/bold/saving-bank-international.svg';

export default builder(
  'IconSavingBankInternationalBold',
  SavingBankInternational,
);
